import { EndpointSelector, RootState } from 'redux/types';
import { createSelector } from 'reselect';

import { INotification, NotificationStatus } from './types';

class NotificationSelector extends EndpointSelector<INotification> {
  constructor() {
    super('notification.data');
  }

  getUnreadNotifications = createSelector([this.getAll], (all) =>
    all.filter((n) => n.status === NotificationStatus.UNREAD),
  );

  isOpen = (state: RootState) => state.notification.isOpen;
}

export default new NotificationSelector();
